/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Divider, Empty, Form, Input, InputNumber } from 'antd';

function TrackingSettings({ fieldsPermissions }) {
  const hasTrackingPermissions =
    fieldsPermissions?.TrackingPointInterval.access !== 0 ||
    fieldsPermissions?.TrackingMinDistance.access !== 0 ||
    fieldsPermissions?.TrackingGeofenceRadius.access !== 0 ||
    fieldsPermissions?.TrackingMaxOfflinePoints.access !== 0 ||
    fieldsPermissions?.TrackingAutoFinishCheckInterval.access !== 0 ||
    fieldsPermissions?.TrackingHealthCheckInterval.access !== 0;

  if (!hasTrackingPermissions)
    return (
      <div style={{ height: 100, width: '100%' }}>
        <Empty description="Nenhuma configuração de rastreamento do treinamento disponível" />
      </div>
    );

  return (
    <>
      <Col span={24}>
        <Divider className="configuration-divider" orientation="left">
          Configurações de Rastreamento
        </Divider>
      </Col>

      {fieldsPermissions?.TrackingPointInterval?.access > 0 && (
        <Col md={6} sm={24}>
          <Form.Item
            label="Intervalo entre Registros (segundos)"
            name="trackingPointInterval"
            required={fieldsPermissions?.TrackingPointInterval?.isRequired}
          >
            <InputNumber min={0} max={30} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.TrackingMinDistance?.access > 0 && (
        <Col md={6} sm={24}>
          <Form.Item
            label="Distância Mínima (metros)"
            name="trackingMinDistance"
            required={fieldsPermissions?.TrackingMinDistance?.isRequired}
          >
            <InputNumber min={0} max={100} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.TrackingGeofenceRadius?.access > 0 && (
        <Col md={6} sm={24}>
          <Form.Item
            label="Raio da Cerca Virtual (metros)"
            name="trackingGeofenceRadius"
            required={fieldsPermissions?.TrackingGeofenceRadius?.isRequired}
          >
            <InputNumber min={0} max={300} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.TrackingMaxOfflinePoints?.access > 0 && (
        <Col md={6} sm={24}>
          <Form.Item
            label="Máximo de Registros Offline"
            name="trackingMaxOfflinePoints"
            required={fieldsPermissions?.TrackingMaxOfflinePoints?.isRequired}
          >
            <InputNumber min={0} max={20000} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.TrackingAutoFinishCheckInterval?.access > 0 && (
        <Col md={6} sm={24}>
          <Form.Item
            label="Intervalo de Finalização Automática (segundos)"
            name="trackingAutoFinishCheckInterval"
            required={fieldsPermissions?.TrackingAutoFinishCheckInterval?.isRequired}
          >
            <InputNumber min={0} max={60} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.TrackingHealthCheckInterval?.access > 0 && (
        <Col md={6} sm={24}>
          <Form.Item
            label="Intervalo de Verificação de Atividade (segundos)"
            name="trackingHealthCheckInterval"
            required={fieldsPermissions?.TrackingHealthCheckInterval?.isRequired}
          >
            <InputNumber min={0} max={60} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.MapBoxToken?.access > 0 && (
        <>
          <Col span={24}>
            <Divider className="configuration-divider" orientation="left">
              Mapbox
            </Divider>
          </Col>

          {fieldsPermissions?.MapBoxToken.access !== 0 && (
            <Col span={6}>
              <Form.Item
                label="Token"
                name="mapBoxToken"
                rules={[
                  {
                    required: fieldsPermissions?.MapBoxToken.isRequired,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Input.Password disabled={fieldsPermissions?.MapBoxToken.access !== 2} />
              </Form.Item>
            </Col>
          )}
        </>
      )}
    </>
  );
}

export default TrackingSettings;
